import React from 'react'
import { pdfMake } from '../../../lib/pdf-make'
import {  Dropdown } from 'react-bootstrap'
import Error_500 from '../../error/error-500'
import { getSignaturesAPI } from '../../../services/signatures'

export default function PDFExportSignature({
  body,
  createEmpsExcelLog2,
  typeName
}) {
  const fnGetSignaturesDetail = async () => {
    try {
     
      const resp = await getSignaturesAPI(body)
      
      if (!resp) return
      if (resp.status) {
        const pdf = resp.result.map((d, i) => {
          return [
            i + 1,
            d.code,
            `${d.name_th} ${d.surname_th}`,
            d.url
              ? {
                  image: d?.url ?? '',
                  width: 60
                }
              : ''
          ]
        })
        fnExportExcel(pdf)
      } else {
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const fnExportExcel = (data) => {
    const pdf = pdfMake.createPdf({
      info: {
        title: 'Signature'
      },
      content: [
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: [30, '*', '*', '*'],
            body: [['#', 'รหัสพนักงาน', 'ชื่อ-นามสกุล', 'ลายเซ็น'], ...data]
          }
        }
        // ...data
      ],
      pageSize: 'A4',
      defaultStyle: {
        fontSize: 10,
        bold: false,
        font: 'THSarabunNew',
        color: '#2A2A2A',
        // alignment: 'justify',
        lineHeight: 1.7
      }
    })

    pdf.open()
    createEmpsExcelLog2(3)
  }
  return (
    <>
      <Dropdown.Item onClick={fnGetSignaturesDetail}>
        <span
          style={{
            fontSize: '14px'
          }}
        >
          {typeName}
        </span>
      </Dropdown.Item>
     
    </>
  )
}
